<template>
    <div>
        <b-card>
            <b-row>
                <b-col v-if="showFilter">
                    <h3>Lotes</h3>
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="showFilter">
                <b-col align-self="end">
                    <label for="">De</label>
                    <date-picker :disabled="lote.length > 0" v-model="fromDate"
                        :config="datePickerConfig"></date-picker>
                </b-col>
                <b-col align-self="end">
                    <label>Até</label>
                    <date-picker :disabled="lote.length > 0" v-model="toDate" :config="datePickerConfig"></date-picker>
                </b-col>
                <b-col>
                    <label for="">Status</label>
                    <b-form-select v-model="status" :options="optionsStatus" />
                </b-col>
                <b-col v-if="!isDistribuidor">
                    <label for="">Classe</label>
                    <b-form-select v-model="classe" :options="['', 'A', 'G', 'P', 'L']" />
                </b-col>
                <b-col align-self="end">
                    <label>Lote</label>
                    <input placeholder="Código" v-model="lote" class="form-control" v-mask="'######'"
                        @keyup.enter="buscaLote" />
                </b-col>
                <b-col v-if="!isDistribuidor">
                    <label for="">Distribuidor</label>
                    <b-input placeholder="Código ou Nome" v-model="distribuidor" @keyup.enter="buscaLote" />
                </b-col>
                <b-col align-self="end" cols='2'>
                    <b-button variant="primary" :disabled="loading" @click="clickBuscaLote">
                        <i class="fas fa-search"></i> Buscar
                    </b-button>
                    <b-button variant="secondary" :disabled="loading" @click="limparFiltros" title="Limpar Filtros">
                        <i class="fas fa-broom fa-rotate-by" style="--fa-rotate-angle: -50deg;"></i>
                    </b-button>
                </b-col>
            </b-row>
            <b-row align-v="center" class="mt-3" v-if="showFilter">
                <b-col sm="7" md="6" class="my-1">
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" align="fill" size="sm"
                        @input="buscaLote" class="my-0" />
                </b-col>
                <b-col md="1">
                    <b-form-select v-model="perPage" :options="optionsPerPage" size="sm"
                        title="Por Página"></b-form-select>
                </b-col>
                <b-col class="text-right">
                    Total: {{ total }}
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-table :items="listaTabela" :fields="showFields" :per-page="perPage" stacked="md" responsive
                    empty-text="Nenhum lote encontrado!" :busy="loading" show-empty small striped hover>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Buscando Lotes...</strong>
                        </div>
                    </template>
                    <template #cell(selected)="row">
                        <input type="checkbox" @click="selectLote" :value="row.item.id"
                            v-if="row.item.status === 'CANCELADO'">
                    </template>
                    <template #cell(actions)="row">
                        <button type="button" v-if="row.item.url_extrato" data-toggle="tooltip" data-placement="top"
                            title="Fatura por Revendedora" @click="getUrl(row.item.url_extrato)"
                            class="btn btn-info btn-sm">
                            <i class="fa fa-list-ol"></i>
                        </button>
                        <button type="button" data-toggle="tooltip" data-placement="top" title="Resumo de Pedido"
                            v-if="row.item.url_resumo" @click="getUrl(row.item.url_resumo)"
                            class="btn btn-primary btn-sm">
                            <i class="far fa-file-alt"></i>
                        </button>
                        <button type="button" data-toggle="tooltip" data-placement="top" title="Nota Fiscal"
                            v-if="row.item.url_nfe || row.item.notas > 0"
                            @click="viewNota(row.item.lote_codigo, 'nota')" class="btn btn-warning btn-sm">
                            <i class="fas fa-file-pdf"></i>
                        </button>
                        <button type="button" data-toggle="tooltip" data-placement="top" title="Devolução"
                            v-if="row.item.url_devolucao || row.item.notas_devolucao"
                            @click="viewNota(row.item.lote_codigo, 'devolucao')" class="btn btn-primary btn-sm">
                            <i class="fa fa-car"></i>
                        </button>
                        <button type="button" data-toggle="tooltip" data-placement="top" title="Histórico"
                            class="btn btn-default btn-sm" @click="showHistory(row.item.id)">
                            <i class="fa fa-history"></i>
                        </button>
                        <downloadexcel type="xls" :name="filename" :fields="json_fields" :worksheet="row.item.nome"
                            class="btn btn-success btn-sm" :title="`Lote ${row.item.lote_codigo}`"
                            :fetch="() => { return startDownload(row.item.id) }">
                            <i class="far fa-file-excel"></i>
                        </downloadexcel>
                        <button type="button" v-show="row.item.url_xml || row.item.notas" data-toggle="tooltip"
                            data-placement="top" title="XML da Nota Fiscal"
                            @click="viewNota(row.item.lote_codigo, 'xml')" class="btn btn-primary btn-sm">
                            <i class="fas fa-file-archive"></i>
                        </button>
                        <button type="button" class="btn btn-primary btn-sm"
                            v-if="row.item.status === 'TRANSPORTADORA' || row.item.status === 'ENTREGUE'"
                            @click="getUrlTransp(row.item.id)" title="Rastreamento">
                            <i class="fa fa-truck"></i>
                        </button>
                        <button type="button" class="btn btn-primary btn-sm"                        
                            v-if="!isDistribuidor && showFilter && (row.item.status === 'CANCELADO')"
                            @click="novoNumeroLote(row.item.id,row.item.lote_codigo)" title="Nova numeração">
                            <i class="fa fa-edit"></i>
                        </button>
                    </template>
                    <template #cell(lote_codigo)="row">
                        <a :href="'/lotes/' + row.item.lote_codigo" target="_blank">{{ row.item.lote_codigo }}</a>
                    </template>
                </b-table>
            </b-row>
            <b-row v-if="!isDistribuidor && showFilter">
                <b-col v-if="listaRecuperar.length > 0">
                    <b-button variant="outline-primary" size="sm" @click="recuperar"><i class="fas fa-recycle"></i>
                        Recuperar</b-button>
                </b-col>
                <b-col class="text-right">
                    Selecionados: {{ listaRecuperar.length }}
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import downloadexcel from "vue-json-excel";

export default {
    props: {
        showFilter: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            json_fields:{
                "Pedido": 'id',
                "Campanha": 'campanha.codigo',
                "Data Criacao": {
                    field: "created_at",
                    callback: (value) => {
                        return moment(value).format('DD/MM/YYYY HH:mm:ss')
                    }
                },
                "Desconto": 'desconto',
                "Status": 'status',
                "Qtd. Itens": 'qtd_itens',
                "Observação": 'observacoes',
                "Cod. Revendedora": 'revendedora.codigo',
                "Revendedora": 'revendedora.nome',
            },
            classe: "",
            status: "",
            distribuidor: "",
            optionsStatus: [
                { value: "", text: '' },
                { value: "ENVIADO", text: 'Enviado' },
                { value: "RECEBIDO", text: 'Recebido' },
                { value: "ANALISE_CREDITO", text: 'Em Análise' },
                { value: "FATURADO", text: 'Faturado' },
                { value: "SEPARANDO", text: 'Em Separação' },
                { value: "TRANSPORTADORA", text: 'Em Transporte' },
                { value: "CANCELADO", text: 'Cancelado' }
            ],
            currentPage: 1,
            perPage: 10,
            total: 0,
            optionsPerPage: [5, 10, 20, 50, 100],
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': true,
                'useCurrent': false,
            },
            toDate: moment(),
            fromDate: moment().subtract(1, 'months'),
            listaTabela: [],
            lote: '',
            loading: false,
            busca: '',
            id: 0,
            listaRecuperar: [],
        }
    },
    components: {
        downloadexcel
    },
    watch: {
        perPage(newValue) {
            this.currentPage = 1
            this.buscaLote()
        }
    },

    methods: {
        async startDownload(id) {
            let valida = false;
            const resposta = await axios.get("/lotes/excel/" + id + "")
                .then(function (response) {
                    $(".loading").hide();
                    valida = true;
                    return response;
                })
                .catch(function (error) {
                    $(".loading").hide();
                    console.log(error);
                    return alert("Erro ao gerar o relatório");
                })

            if (valida) {
                console.log(resposta);
                return resposta.data.pedidos;
            }

        },
        async histTable(hist) {
            var vm = this;
            var html = '';
            await hist.forEach((a, b) => {
                const status = vm.getStatus(a.status)
                html += '<tr><td>' + status + '</td><td>' + vm.formatDateHour(a.created_at) + '</td></tr>'
            });
            return html;
        },
        async showHistory(id) {
            var vm = this;
            var hist = [];
            $('.loading').show();
            await axios.get('/lotes/historico/' + id).then((response) => {
                $('.loading').hide();
                hist = response.data;
                vm.histTable(hist).then((table) => {
                    vm.$swal({
                        icon: 'info',
                        title: 'Histórico',
                        html: '<table class="table table-bordered table-striped">' +
                            '<thead>' +
                            '<tr>' +
                            '<td>Status</td>' +
                            '<td>Data da Modificação</td>' +
                            '</tr>' +
                            '</thead>' +
                            '<tbody>' +
                            table +
                            '</tbody>' +
                            '</table>',
                        showCloseButton: true,
                        focusConfirm: false,
                    })
                })
            }).catch((error) => {
                let errors = error.response.data;
                vm.$swal('Ops', errors.join('\n'), 'error')
                console.log(errors);
                $('.loading').hide();
            });
        },
        viewNota(codigo, tipo) {
            const vm = this;
            const params = {
                tipo: tipo,
                lote: codigo
            }
            axios.get('/get-link', { params: params })
                .then((response) => {
                    window.open('/lote/nf/' + response.data.resource, '_blank');
                }).catch((error) => {
                    console.log(error);
                })
        },
        limparFiltros() {
            this.lote = '';
            this.status = '';
            this.distribuidor = '';
            this.classe = '';
            this.toDate = moment(),
                this.fromDate = moment().subtract(1, 'months'),
                this.currentPage = 1
            this.buscaLote();
        },
        clickBuscaLote() {
            this.currentPage = 1;
            this.buscaLote();
        },
        selectLote(event) {
            var check = event.target.checked;
            if (check) {
                this.listaRecuperar.push(event.target.value);
            } else {
                this.listaRecuperar = this.listaRecuperar.filter((el) => {
                    return el !== event.target.value
                })
            }
        },
        recuperar() {
            const vm = this;
            if (this.listaRecuperar.length === 0) {
                vm.$swal('Atenção', 'Nenhum lote selecionado', 'error');
                return;
            }
            vm.$swal({
                title: this.listaRecuperar.length + ' Lote(s) Selecionado(s)!',
                text: 'Deseja realmente recuperar os(s) lote(s) Selecionado(s)?',
                footer: 'Esta ação não poderá ser revertida!',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, recuperar!',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    $('.loading').show();
                    axios.post('/lotes/recuperar', {
                        lotes: vm.listaRecuperar
                    }).then((response) => {
                        let obj = response.data;
                        $('.loading').hide();
                        vm.loadDataLote()
                        if (obj.success) {
                            vm.$swal('Ok', obj.success, 'success');
                        }
                    }).catch((e) => {
                        vm.$swal({
                            title: e.response.data.errors,
                            icon: 'error',
                        });
                        $('.loading').hide();
                    });
                }
            })
        },

        formatDate(value) {
            return moment(value).format('DD/MM/YYYY');
        },

        buscaLote() {
            this.loadDataLote();
        },
        loadDataLote() {
            var vm = this;
            let params = {};
            vm.listaTabela = [];
            vm.listaRecuperar = [];
            if (this.lote) {
                params.lote_codigo = this.lote;
            } else {
                if (typeof this.toDate === 'string') {
                    let _toDate = this.toDate.split('/');
                    this.toDate = moment(_toDate[2] + '-' + _toDate[1] + '-' + _toDate[0]);
                }
                if (typeof this.fromDate === 'string') {
                    let _fromDate = this.fromDate.split('/');
                    this.fromDate = moment(_fromDate[2] + '-' + _fromDate[1] + '-' + _fromDate[0]);
                }
                params.end = this.toDate.format('YYYY-MM-DD')
                params.start = this.fromDate.format('YYYY-MM-DD')               
            }
            params.page = this.currentPage;
            params.perPage = this.perPage;
            params.lote = this.lote;
            params.status = this.status;
            params.distribuidor = this.distribuidor;
            params.classe = this.classe;
            vm.loading = true;
            axios.get('/lotes', { params: params })
                .then((response) => {
                    vm.listaTabela = response.data.data;
                    vm.listaTabela.forEach((el) => {
                        el.selecionado = false;
                    })
                    vm.total = response.data.total
                }).catch((err) => {
                    console.log(err);
                    vm.$swal('Erro', 'houve um erro ao carregar lotes', err);
                }).finally(() => {
                    vm.loading = false;
                })
        },
        getUrlTransp(id) {
            var vm = this
            axios.get("/tracking/" + id).then((response) => {
                var data = response.data;
                if (typeof (data.URL) !== 'undefined') {
                    window.open(data.URL, '_blank');
                } else if (typeof (data.MSG) !== 'undefined') {
                    vm.$swal('Atenção', data.MSG, 'warning');
                }

            }).catch((error) => {
                console.log(error);
                $('#mensagem').append(data.MSG);
                vm.$swal('Atenção', data.MSG, 'error');
            });
        },
        novoNumeroLote(id,codigo){
         const vm = this;
            
            vm.$swal({
                title: ' Nova numeração para o lote '+codigo,
                text: 'Deseja realmente gerar uma nova numeração?',
                footer: 'Esta ação não poderá ser revertida!',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, gerar!',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    $('.loading').show();
                    axios.post('/lotes/nova-numeracao', {
                        id: id
                    }).then((response) => {
                        let obj = response.data;
                        $('.loading').hide();
                        vm.loadDataLote()
                        if (obj.success) {
                            vm.$swal('Ok', obj.success, 'success');
                        }
                    }).catch((e) => {
                        vm.$swal({
                            title: e.response.data.errors,
                            icon: 'error',
                        });
                        $('.loading').hide();
                    });
                }
            })
        },
        formatDate(date) {
            return moment(date).format("DD/MM/Y");
        },
        formatDateHour(date) {
            return moment(date).format("DD/MM/Y HH:mm:ss");
        },

        getStatus(status) {
            if (status === "TRANSPORTADORA") {
                return 'Em Transporte';
            } else if (status === "ANALISE_CREDITO") {
                return 'Em Análise';
            } else if (status === "CANCELADO") {
                return 'Cancelado';
            } else if (status === "FATURADO") {
                return 'Faturado';
            } else if (status === "RECEBIDO") {
                return 'Recebido';
            } else if (status === "SEPARANDO") {
                return 'Em Separação'
            } else if (status === "ENVIADO") {
                return 'Enviado'
            } else {
                return '-'
            }
        },
        getUrl(url) {
            window.open('/' + url, '_blank')
        },
        getTipo(item) {
            if(item.kit_personalizado) return 'Kit Personalizado'
            else if(item.cashback && item.cashback > 0) return 'Cashback';
            else return 'Normal'
        }
    },
    computed: {
        filename() {
            const data = new Date();
            return `${data.getTime()}.xls`;
        },
        showResumo() {
            var classe = $("#classe").val();
            if (classe === "A" || classe === "D") {
                return true;
            }
            return false;
        },



        showFields() {
            let fields = [
                { key: 'recuperar', label: '' },
                { key: 'lote_codigo', label: 'Lote' },
                {
                    key: 'status', label: 'Status',
                    formatter: (value) => {
                        return this.getStatus(value)
                    }
                },
                {
                    key: 'created_at', label: 'Data',
                    formatter: (value) => {
                        return this.formatDate(value)
                    }
                },
                { key: 'qtd_pedidos', label: 'Pedidos', class: 'text-center' },
                { key: 'qtd_itens', label: 'Itens', class: 'text-center' },
                { key: 'qtd_estoque', label: 'Estoque', class: 'text-center' },
                { key: 'actions', label: '' },
            ]
            if (!this.isDistribuidor) {
                fields = [
                    { key: 'selected', label: '' },
                    { key: 'lote_codigo', label: 'Lote' },
                    { key: 'codigo_antigo', label: 'Lote Anterior' },
                    { key: 'uf', label: 'UF' },
                    {
                        key: 'distribuidor', label: 'Distribuidor',
                        formatter: (value, key, item) => {
                            return item.codigo + ' - ' + item.nome
                        },
                    },
                    { key: 'classe', label: 'Classe', class: 'text-center' },
                    {
                        key: 'status', label: 'Status',
                        formatter: (value) => {
                            return this.getStatus(value)
                        }
                    },
                    {
                        key: 'created_at', label: 'Data',
                        formatter: (value) => {
                            return this.formatDate(value)
                        }
                    },
                    { key: 'campanha', label: 'Campanha', class: 'text-center' },
                    {
                        key: 'tipo', label: 'Tipo', class: 'text-center',
                        formatter: (value, key, item) => {
                            return this.getTipo(item)
                        }
                    },
                    { key: 'qtd_pedidos', label: 'Pedidos', class: 'text-center' },
                    { key: 'qtd_itens', label: 'Itens', class: 'text-center' },
                    { key: 'qtd_estoque', label: 'Estoque', class: 'text-center' },
                    { key: 'actions', label: '' },
                ]
            }
            return fields
        },
        isDistribuidor() {
            if (parseInt($('#is_distribuidor').val()) > 0) {
                return true;
            }
            return false;
        },

    },

    mounted() {
        this.loadDataLote();
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/lote/List.vue